import { CategoriesModel } from "@interfaces/index";

export const getSubcategoryById = (
  categories?: CategoriesModel,
  id?: string,
) => {
  if (!id) {
    return undefined;
  }

  const income = categories?.income || [];
  const expense = categories?.expense || [];
  const cat = [...income, ...expense].find((cat) =>
    cat.subcategories.find((subcat) => subcat.uniqueId === id),
  );

  return cat?.subcategories.find((subcat) => subcat.uniqueId === id);
};
